module.exports = __webpack_public_path__ + "img/side seam.e091b8ba.png";